import { gql } from "@apollo/client";

const GET_VENDOR_BRAND_LIST = gql`
  query {
    getVendorBrandList {
      data {
        brandName
        _id
      }
      status
      error
    }
  }
`;

export default GET_VENDOR_BRAND_LIST;
